import { set } from '@/utils/vuex'

export default {
  setInitialized: set('initialized'),
  setUser: set('user'),
  setConfig: set('config'),
  setCompany: set('company'),
  setDeliveryGroupId: set('deliveryGroupId'),
  setGlobalSnackBarText: set('globalSnackBarText'),
  setShowQuestionnaire: set('showQuestionnaire')
}
